import { Component } from 'react';
import { Field } from 'redux-form';
import { SelectField } from './SelectField';
import { IwDynamicFormattedMessage } from '../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';
import messages from './Select.messages';
import { FormattedMessage } from 'react-intl';

export class Select extends Component {
    handleChange = (selectedOption) => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(selectedOption.value);
        }
    };

    handleOptionAndValueRenderer = ({ value, mappedValue, label }) => {
        return (
            <IwDynamicFormattedMessage
                messages={this.props.messages}
                messageKey={mappedValue || value}
                defaultMessage={label}
            />
        );
    };

    renderSelect = () => {
        const { valueComponent, optionComponent } = this.props.selectOptions;
        // eslint-disable-next-line react/display-name
        return (props) => (
            <SelectField
                optionRenderer={
                    optionComponent
                        ? undefined
                        : this.handleOptionAndValueRenderer
                }
                valueRenderer={
                    valueComponent
                        ? undefined
                        : this.handleOptionAndValueRenderer
                }
                {...this.props.selectOptions}
                {...props}
            />
        );
    };

    render() {
        const { placeholder } = this.props;

        return (
            <Field
                className={this.props.className}
                label={this.props.label}
                hideError={this.props.hideError}
                onChange={this.handleChange}
                name={this.props.name}
                validate={this.props.validate}
                component={this.renderSelect()}
                data-testid={this.props['data-testid']}
                disabled={this.props.disabled}
                placeholder={
                    placeholder ? (
                        placeholder
                    ) : (
                        <FormattedMessage {...messages.defaultPlaceholder} />
                    )
                }
            />
        );
    }
}
